var Types;
(function (Types) {
    Types["CAUTION"] = "caution";
    Types["DANGER"] = "danger";
    Types["NEUTRAL"] = "neutral";
    Types["NOTICE"] = "notice";
    Types["SAFETY"] = "safety";
    Types["WARNING"] = "warning";
})(Types || (Types = {}));
export default Types;
//# sourceMappingURL=type.js.map